import { render, staticRenderFns } from "./PageContracting.vue?vue&type=template&id=47bcd8ad&scoped=true&"
import script from "./PageContracting.vue?vue&type=script&lang=js&"
export * from "./PageContracting.vue?vue&type=script&lang=js&"
import style0 from "./PageContracting.vue?vue&type=style&index=0&id=47bcd8ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bcd8ad",
  null
  
)

export default component.exports